import { make } from 'redux-chill';

const setReviewInfoUt = make('[delivery] set reviewUt info').stage('reset');

export { setReviewInfoUt };
